import React from "react";
const Loading = () => {
  return <div class="loader">Loading...</div>;
};
export default Loading;
